export const heronSquarePattern = [
    {
        // Group 1
        x: 0,
        y: -30,
        parallaxSpeed: 450,
        squares: [
            // Group 1, Squares
            {
                // 1
                size: 79,
                x: 0,
                y: 0,
                opacity: 0.1,
                color: '#6679FF'
            },
            {
                // 2
                size: 79,
                x: 79,
                y: 0,
                opacity: 0.1,
                color: '#0072EB'
            },
            {
                // 3
                size: 79,
                x: 158,
                y: 0,
                opacity: 0.1,
                color: '#0072EB'
            },
            {
                // 4
                size: 237,
                x: 237,
                y: 79,
                opacity: 0.1,
                color: '#6679FF'
            },
            {
                // 5
                size: 79,
                x: 474,
                y: 237,
                opacity: 0.1,
                color: '#0047AD'
            },
            {
                // 6
                size: 79,
                x: 395,
                y: 237,
                opacity: 0.1,
                color: '#6679FF'
            },
            {
                // 7
                size: 79,
                x: 395,
                y: 316,
                opacity: 0.1,
                color: '#6679FF'
            },
            {
                // 8
                size: 79,
                x: 474,
                y: 395,
                opacity: 0.1,
                color: '#0047AD'
            },
            {
                // 9
                size: 79,
                x: 316,
                y: 316,
                opacity: 0.1,
                color: '#0047AD'
            },
            {
                // 10
                size: 79,
                x: 237,
                y: 316,
                opacity: 0.1,
                color: '#6679FF'
            },
            {
                // 11
                size: 158,
                x: 790,
                y: 395,
                opacity: 0.1,
                color: '#6679FF'
            },
            {
                // 12
                size: 79,
                x: 0,
                y: 158,
                opacity: 0.1,
                color: '#6679FF'
            },
            {
                // 13
                size: 79,
                x: 474,
                y: 0,
                opacity: 0.1,
                color: '#0047AD'
            },
            {
                // 14
                size: 79,
                x: 553,
                y: 0,
                opacity: 0.1,
                color: '#0047AD'
            },
            {
                // 15
                size: 79,
                x: 553,
                y: 79,
                opacity: 0.1,
                color: '#0072EB'
            },
            {
                // 16
                size: 79,
                x: 553,
                y: 158,
                opacity: 0.1,
                color: '#6679FF'
            },
            {
                // 17
                size: 79,
                x: 632,
                y: 237,
                opacity: 0.1,
                color: '#0047AD'
            },
            {
                // 18
                size: 79,
                x: 632,
                y: 316,
                opacity: 0.1,
                color: '#6679FF'
            },
            {
                // 19
                size: 79,
                x: 711,
                y: 395,
                opacity: 0.1,
                color: '#0047AD'
            },
            {
                // 20
                size: 79,
                x: 632,
                y: 474,
                opacity: 0.1,
                color: '#0047AD'
            },
            {
                // 21
                size: 79,
                x: 632,
                y: 474,
                opacity: 0.1,
                color: '#0047AD'
            }
        ]
    }
];
